document.querySelectorAll("input[name='Color']").forEach(function(obj) {
  obj.addEventListener("change", function(e) {
    console.log(obj.value);
    var hdl = "#colour_" + obj.value.toLowerCase().trim().replace(" ", "-").replace("/", "-");

    document.querySelectorAll(".product-images__slide").forEach(function(obj1) {
      alt = obj1.getAttribute("data-alt");

      if(!alt || alt == '' || alt == hdl) {
        obj1.classList.remove("hide");
      }
      else {
        obj1.classList.add("hide");
      }
    });
  });
});

document.querySelectorAll("input[name='Colour']").forEach(function(obj) {
  obj.addEventListener("change", function(e) {
    console.log(obj.value);
    var hdl = "#colour_" + obj.value.toLowerCase().trim().replace(" ", "-").replace("/", "-");

    document.querySelectorAll(".product-images__slide").forEach(function(obj1) {
      alt = obj1.getAttribute("data-alt");

      if(!alt || alt == '' || alt == hdl) {
        obj1.classList.remove("hide");
      }
      else {
        obj1.classList.add("hide");
      }
    });
  });
});

if(document.querySelector("input[name='Color']:checked")) {
  var evt = document.createEvent("HTMLEvents");
  evt.initEvent("change", false, true);
  document.querySelector("input[name='Color']:checked").dispatchEvent(evt);
}

if(document.querySelector("input[name='Colour']:checked")) {
  var evt = document.createEvent("HTMLEvents");
  evt.initEvent("change", false, true);
  document.querySelector("input[name='Colour']:checked").dispatchEvent(evt);
}

//Filter country
let url = window.location.href;
if(url.includes("/fr")) {
  document.querySelector("body").classList.add("show_fr");
  if(document.querySelector(".sizechart_body")) {
    document.querySelector(".sizechart_body").classList.add("show_fr");
  }
}

document.querySelectorAll(".unit-switch").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    console.log("unit-switch clicked");
    obj.parentElement.querySelectorAll(".unit-switch").forEach(function(obj1) {
      obj1.classList.remove("active");
    });

    var modal = obj.closest(".product-popup-modal");

    obj.classList.add("active");
    if (obj.classList.contains("show_cm")) {
      modal.querySelector(".sizechart_table").classList.add("unit_cm");
    }
    else {
      modal.querySelector(".sizechart_table").classList.remove("unit_cm");
    }
  });
});